<template>
    <div class="select">
      <button class="button primary" @click="isVisible = true"><slot name="button"></slot></button>
      <div class="select-box-app" v-show="isVisible">
          <div class="overlay" @click="isVisible = false"></div>
          <div class="select-box">
              <h5><slot name="title"></slot></h5>
              <div class="content">
                <slot name="content"></slot>
              </div>
              <div class="close-btn">
                <button type="button" @click="isVisible = false" class="button close">Kapat</button>
              </div>
          </div>
      </div>
    </div>
</template>
<script>
  export default{
    props: ['button'],
    data(){
      return{
          isVisible: false,
      }
    },
    watch:{
      isVisible(val){
        if(val){
          document.querySelector("#app").classList.add('lock');
        }else{
          document.querySelector("#app").classList.remove('lock');
        }
      }
    }
  }
</script>